import React from 'react';
import './App.css';
import { Chatbox } from './Components/Chatbox';

function App() {
  return (
    <>
      <Chatbox/>
    </>
  );
}

export default App;
